import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services';
import { CheckOutService } from '../../../services/checkout.service';
import { ApiResponse } from '../../../models/api-response.model';
import { AccountDeliveryAddress, PostcodeList, SuburbList } from '../../../models/account-delivery-address';
import { Router } from '@angular/router';
import { StateModel } from '../../../models/account-ledger.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { MyAccountService } from '../../../services/myAccount.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-edit-delivery-address',
  templateUrl: './edit-delivery-address.component.html',
  styleUrls: ['./edit-delivery-address.component.css']
})
export class EditDeliveryAddressComponent implements OnInit {

  addressFormGroup: FormGroup;
  loadContent = false;
  deliveryAddressList: AccountDeliveryAddress[];
  address: AccountDeliveryAddress;
  stateList: string[];
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  selectedAddress: AccountDeliveryAddress;
  account_validation_messages: any = {
    'companyName': [
      { class: 'companyName', message: 'Please enter company name' }
    ],
    'attnOrRef': [
      { class: 'attnRef', message: 'Please enter attn or ref' }
    ],
    'addressLine1': [
      { class: 'addressLine1', message: 'Please enter address' }
    ],
    'suburb': [
      { class: 'suburb', message: 'Please enter suburb' }
    ],
    'state': [
      { class: 'state', message: 'Please enter state' }
    ],
    'postcode': [
      { class: 'postcode', message: 'Please enter postcode' }
    ],
    'phone': [
      { class: 'phone', message: 'Please enter phone' }
    ]
  };

  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private checkOutService: CheckOutService,
    private shoppingCartService: ShoppingCartService,
    private myAccountService: MyAccountService,
    private router: Router,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.addressFormGroup = this.formBuilder.group({
      companyName: new FormControl('', [Validators.required]),
      attnOrRef: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl('', []),
      addressLine3: new FormControl('', []),
      suburb: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      postcode: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      naType: new FormControl(''),
      action: new FormControl(''),
      combinedAddress: new FormControl('')
    });
  }

  ngOnInit() {
    this.myAccountService.currentAddress.subscribe((result: AccountDeliveryAddress) => {
      if (result) {
        this.loadContent = false;
        this.shoppingCartService.getState().subscribe((res: StateModel) => {
          this.stateList = res.states;
          this.loadContent = true;
          this.addressFormGroup.setValue(result);
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      } else {
        this.loadContent = true;
        this.close();
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  saveAddressToAccount() {
    if (this.addressFormGroup.valid) {
      this.loadContent = false;
      this.addressFormGroup.get('action').setValue('U');
      this.checkOutService.setAccountAddress(this.addressFormGroup.value).subscribe((res: ApiResponse) => {
        this.loadContent = true;
        if (res.status) {
          let message = '';
          switch (this.addressFormGroup.get('action').value) {
            case 'I':
              message = 'New delivery address created.';
              break;
            case 'U':
              message = 'The address was successfully updated.';
              break;
            case 'D':
              message = 'The address was successfully deleted.';
              break;
          }
          this.commonService.implementToast(message, 'Success');
          setTimeout(() => {
            this.checkOutService.deliveryAddressBook$.next();
            this.close();
          }, 1500);
        } else {
          const errorMessage = (res.responseMessage) ? res.responseMessage : 'Failed To Saved';
          this.commonService.implementToast(errorMessage, 'Error');
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
          this.commonService.implementToast('Error occured', 'Error');
        });
    } else {
      this.isNotValidField('companyName', this.account_validation_messages.companyName);
      this.isNotValidField('attnOrRef', this.account_validation_messages.attnOrRef);
      this.isNotValidField('addressLine1', this.account_validation_messages.addressLine1);
      this.isNotValidField('suburb', this.account_validation_messages.suburb);
      this.isNotValidField('state', this.account_validation_messages.state);
      this.isNotValidField('postcode', this.account_validation_messages.postcode);
      this.isNotValidField('phone', this.account_validation_messages.phone);
    }
  }

  deleteAddress(): void {
    this.addressFormGroup.get('action').setValue('D');
    this.checkOutService.setAccountAddress(this.addressFormGroup.value).subscribe((res: ApiResponse) => {
      this.loadContent = true;
      if (res.status) {
        let message = '';
        switch (this.addressFormGroup.get('action').value) {
          case 'I':
            message = 'New delivery address created.';
            break;
          case 'U':
            message = 'The address was successfully updated.';
            break;
          case 'D':
            message = 'The address was successfully deleted.';
            break;
        }
        this.commonService.implementToast(message, 'Success');
        setTimeout(() => {
          this.checkOutService.deliveryAddressBook$.next();
          this.close();
        }, 1500);
      } else {
        const errorMessage = (res.responseMessage) ? res.responseMessage : 'Failed To Saved';
        this.commonService.implementToast(errorMessage, 'Error');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
        this.commonService.implementToast('Error occured', 'Error');
      });
  }

  isNotValidField(path: string, validation: any): void {
    if (this.addressFormGroup.get(path).hasError('required')) {
      this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.addressFormGroup.get('postcode').setValue(option.postcode);
    this.addressFormGroup.get('state').setValue(option.state);
    this.addressFormGroup.get('suburb').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.addressFormGroup.get('postcode').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.addressFormGroup.get('state').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.addressFormGroup.get('suburb').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.addressFormGroup.get('postcode').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.addressFormGroup.get('state').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.addressFormGroup.get('suburb').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  startFilterSub(suburbs: PostcodeList[]): void {

    this.filteredSub = suburbs;

  }

  startFilterPostcode(postcodes: PostcodeList[]) {
    this.filteredPostCode = postcodes;
  }

  onInputSub(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.addressFormGroup.get('addressLine1').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.addressFormGroup.get('addressLine2').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.addressFormGroup.get('addressLine3').setValue(event.target.value);
    }
  }
  close() {
    this.router.navigateByUrl('/myAccount/deliverylocations');
  }
}
